export default __webpack_public_path__ + "static/media/trillion-reversed.0f6eafd8.svg";